export const trackingDeviceList = [
  {
    label: 'PT 10',
    value: 'PT10',
  },
  {
    label: 'Geometris',
    value: 'Geometris',
  },
];
